import type { ArtistSummary, ChartmetricSnapshot } from '@dashboard/contract';
import { fmtBig, fmtM } from '../lib/format';

export function Hero({
  summary,
  cm,
}: {
  summary: ArtistSummary;
  cm: ChartmetricSnapshot | null | undefined;
}) {
  const ww = summary.hero.ltmWorldwide;
  return (
    <div className="hero">
      <span className="big">{(ww / 1e9).toFixed(2)}bn</span>
      <span className="cap">audio streams worldwide, last twelve months</span>
      <span className="sep">|</span>
      <span className="big">{fmtM(summary.hero.perDay)}M</span>
      <span className="cap">per day</span>
      {summary.artistLevel.tracksCoverage !== null ? (
        <>
          <span className="sep">|</span>
          <span className="big">{(summary.artistLevel.tracksCoverage * 100).toFixed(0)}%</span>
          <span className="cap">of the artist-level total held as tracks</span>
        </>
      ) : null}
      {cm?.stats.spMonthlyListeners != null ? (
        <>
          <span className="sep">|</span>
          <span className="big">{fmtBig(cm.stats.spMonthlyListeners)}</span>
          <span className="cap">Spotify monthly listeners</span>
        </>
      ) : null}
    </div>
  );
}
